export default {
    getNotfications: state => state.notifications,
    getStoredNotfications: state => state.storedNotifications,
    getSocketConnection: state => state.socketConnection
};